<div class="container" style="padding-top:200px;">
  <br><br>
  <app-breadcrumb category="My Account / My Orders"></app-breadcrumb>
</div>
<br>

<div class="row">
  <div class="col-lg-1">
  </div>
  <div class="col-lg-2">
    <div class="container">
      <h5>my account</h5>
      <li>
      Account Information
    </li><br>
    My orders <br>
    <a href="#">Logout</a><br><br>
    </div>
  </div>

    <div class="col-lg-9">
      <h5 style="margin-left: 20px;">my orders</h5>
      <br>
      <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <img src="../../assets/images/png/cart/men.png" alt="">
        </div>
        <div class="col-lg-4" style="padding: 20px;">
          <small class="text-muted float-left">Order no: </small><small
            class="text-muted float-right">09013456</small><br>
          <p>Estimated delivery: 3 to 5 Business days</p><br>
          <small class="text-muted float-left">Color:</small> <small class="text-muted float-right">White</small><br>
          <small class="text-muted float-left">Size:</small> <small class="text-muted float-right">Large/40</small><br>
          <b class="float-right">Rs.899</b><br>
          <button class="btn first-btn">Buy it again</button><br>
        </div>&nbsp;
        <div class="col-lg-3">
          <button class="btn btn-block second-btn">Track order</button><br>
          <button class="btn btn-block third-btn">Order details</button><br>
          <button class="btn btn-block fourth-btn">Cancel order</button>
        </div>
      </div><br>
      <div class="order-completed" id="order-completed">
        <div class="row">
          <div class="col-lg-3">
            <img src="../../assets/images/png/cart/men.png" alt="">
          </div>
          <div class="col-lg-4" style="padding: 20px;">
            <small class="text-muted float-left">Order no: </small><small
              class="text-muted float-right">09013456</small><br>
            <p>Estimated delivery: 3 to 5 Business days</p><br>
            <small class="text-muted float-left">Color:</small> <small class="text-muted float-right">White</small><br>
            <small class="text-muted float-left">Size:</small> <small class="text-muted float-right">Large/40</small><br>
            <b class="float-right">Rs.899</b><br>
            <button class="btn first-btn">Buy it again</button><br>
          </div>&nbsp;
          <div class="col-lg-3">
            <button class="btn btn-block completed-btn">Track order</button><br>
            <button class="btn btn-block completed-btn">Order details</button><br>
            <button class="btn btn-block completed-btn">Cancel order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
